import { Button } from '../button';

/**
 * @deprecated Use `Button` from `@joinrepublic/dls-ui-kit` instead.
 */
export const ActionButton = Button;
